import React from 'react';
import { Plus } from 'lucide-react';
import { getDeviceIcon } from './helpers';

const DevicesCard = ({ devices, blockers, canAddDevices, hasEditAccess, onAddDevice }) => (
  <div className="bg-surface border border-border rounded-lg p-4" data-testid="devices-card">
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-heading font-semibold text-text-primary">Devices</h2>
      {canAddDevices && hasEditAccess && (
        <button
          onClick={onAddDevice}
          className="flex items-center gap-1 px-3 py-1.5 text-sm bg-surface-highlight text-text-primary rounded-md hover:bg-border transition-colors"
          data-testid="add-device-btn"
        >
          <Plus size={16} />
          Add Device
        </button>
      )}
    </div>
    {devices.length === 0 ? (
      <p className="text-text-secondary text-sm">No devices added yet</p>
    ) : (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {devices.map((device) => {
          const Icon = getDeviceIcon(device.device_type);
          const activeBlockers = blockers.filter(b => b.device_type === device.device_type && b.status === 'Active').length;
          return (
            <div key={device.device_type} className="p-3 bg-background rounded-md border border-border">
              <div className="flex items-center gap-2 mb-2">
                <Icon size={20} className="text-text-secondary" />
                <span className="font-medium text-text-primary">{device.device_type}</span>
              </div>
              <p className="text-2xl font-bold text-text-primary">{device.quantity}</p>
              {activeBlockers > 0 && (
                <p className="text-xs text-destructive mt-1">{activeBlockers} active blocker(s)</p>
              )}
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default DevicesCard;
